import { useEffect, useState } from "react";

import {
  getSessionStorageValue,
  getStorageKey,
  setSessionStorageValue,
} from "shared/functions";
import { useConfigContext } from "shared/hooks";

const popupClosedByUserKey = "popupClosedByUserKey";

function usePopupClosedByUser(botInfoId: string) {
  const { instanceName } = useConfigContext();

  const [popupClosedByUser, _setPopupClosedByUser] = useState(true);

  useEffect(() => {
    _setPopupClosedByUser(
      !!getSessionStorageValue(
        getStorageKey(instanceName, botInfoId, popupClosedByUserKey),
      ),
    );
  }, [botInfoId, instanceName]);

  const setPopupClosedByUser = (value: boolean) => {
    _setPopupClosedByUser(value);
    setSessionStorageValue(
      getStorageKey(instanceName, botInfoId, popupClosedByUserKey),
      "true",
    );
  };

  return {
    popupClosedByUser,
    setPopupClosedByUser,
  };
}

export default usePopupClosedByUser;
